function Browser() {

	this.isIOS = (/iPhone|iPad|iPod/i).test(navigator.userAgent);
	this.isOnline = (window.location.protocol === 'http:' || window.location.protocol === 'https:');
	this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0; // Opera 8.0+
	this.isFirefox = typeof InstallTrigger !== 'undefined'; // Firefox 1.0+
	this.isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0; // At least Safari 3+
	this.isChrome = !!window.chrome && !this.isOpera; // Chrome 1+ //WARNING : IE12-20 (MS EDGE) && Firefox sept.
	this.isIE = /*@cc_on!@*/ false || !!document.documentMode; // At least IE6
	this.isIE9 = /msie 9/i.test(navigator.userAgent);
	this.isMobile = /iPhone|Android.*Mobile/i.test(navigator.userAgent);
	this.isTablet = /iPad|Android(?!.*Mobile)/i.test(navigator.userAgent);

}

module.exports = new Browser();
